let i18nInstance = null;

export function setI18n(i18n) {
  i18nInstance = i18n;
}

export function translateI18n(key, ...params) {
  if (i18nInstance) {
    return i18nInstance.t(key, ...params);
  }
  return key; 
}